module.exports = __webpack_public_path__ + "img/ANTENNA PALMA BW.2e36598.svg";